import { ReactNode } from "react";
import { createRoot } from "react-dom/client";

export const registerReactComponent = (elementId: string, component: ReactNode) => {
  const container = document.getElementById(elementId);
  if (!container) {
    console.log("[React] Cannot find element by id:", elementId, ". Skipping render...");
    return;
  }

  console.log("[React] Attempting to render island:", elementId);
  try {
    const root = createRoot(container);
    root.render(component);
    console.log("[React] Successfully rendered component", elementId);
  } catch (error) {
    console.log("[React] Error while rendering", elementId, error);
  }
};
